import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    CardActions,
    Button,
    Grid,
    TextField,
    Modal,
    IconButton,
    CircularProgress,
    Divider,
    Avatar,
    Chip,
    Paper,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import {
  Close,
  CalendarToday,
  Update,
  Visibility
} from '@mui/icons-material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
    Save as SaveIcon,
    Close as CloseIcon,
    Info,
} from "@mui/icons-material";
import axios from "axios";
import Cookies from "js-cookie";
import useNotification from "../common/Notification";
import { useNavigate } from "react-router-dom";
import base_url from "../../constants";
import { blue } from "@mui/material/colors";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "800px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    maxHeight: "90vh",
    overflowY: "auto",
};

const CreateTemplate = () => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [currentTemplate, setCurrentTemplate] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [newTemplate, setNewTemplate] = useState({
        template_title: "",
        template: "",
    });
    const navigate = useNavigate()
    const [isCreating, setIsCreating] = useState(false);
     const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const notify = useNotification();
    const userId = Cookies.get("userId");
    const userRole = Cookies.get("userRole")?.split(",")[0];

    console.log("USER ROLE: ", userRole)
    useEffect(() => {
        fetchTemplates();
    }, []);

    const fetchTemplates = async () => {
        try {
            setLoading(true);
            const response = await axios.post( base_url+
                "/whatsapp-template/getbyroleanduserid",
                {
                     
                        user_id :userId,
                        role: 'PERSONAL',
                    
                },
                {
                headers: {
                    "Content-Type": "application/json",
                },
            }
            );
            setTemplates(response.data.data);
        } catch (error) {
            console.error("Error fetching templates:", error);
            // notify("Failed to fetch templates", "error");
        } finally {
            setLoading(false);
        }
    };

     const handleCloseViewModal = () => {
       setSelectedTemplate(null)
       setOpenViewModal(false)
    };

    const handleViewTemplate = (template) => {
        setSelectedTemplate(template)
        setOpenViewModal(true)
    }

    const handleOpenModal = (template = null) => {
        if (template) {
            setCurrentTemplate(template);
            setIsEditing(true);
        } else {
            setCurrentTemplate(null);
            setIsEditing(false);
            setNewTemplate({ title: "", content: "" });
            setIsCreating(true);
        }
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setCurrentTemplate(null);
        setIsEditing(false);
        setIsCreating(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (isEditing) {
            setCurrentTemplate((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setNewTemplate((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSaveTemplate = async () => {
        try {
            if (isEditing) {

                 await axios.post(
                    "http://api.virtualprachar.com/api/whatsapp-template/update",
                    {
                        template_id: currentTemplate.id,
                        user_id: userId,
                        role: userRole,
                        title: currentTemplate.template_title,
                        template: currentTemplate.template,
                    }
                );
                notify("Template updated successfully", "success");
            } else {
 
                await axios.post(
                    "http://api.virtualprachar.com/api/whatsapp-template/create",
                    {
                        user_id: userId,
                        role: userRole,
                        title: newTemplate.template_title,
                        template: newTemplate.template,   
                    },{
                headers: {
                    "Content-Type": "application/json",
                },
            }
                );
                notify("Template created successfully", "success");
            }
            fetchTemplates();
            handleCloseModal();
        } catch (error) {
            console.error("Error saving template:", error);
            notify("Failed to save template", "error");
        }
    };

    const handleDeleteTemplate = async (templateId) => {
        try {
            await axios.post(
                "http://api.virtualprachar.com/api/whatsapp-template/delete",
                {
                        template_id:templateId,
                       user_id: userId,
                        role: userRole,
                }
            );
            notify("Template deleted successfully", "success");
            fetchTemplates();
        } catch (error) {
            console.error("Error deleting template:", error);
            notify("Failed to delete template", "error");
        }
    };

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                }}
            >
                <Typography variant='h6'  sx={{ mb: 4, mt: 3, color : 'primary.main', backgroundColor:blue[50], px:2, width: 'fit-content', py:1, borderRadius:2, fontWeight:'bold'}}>
                    Whatsapp Templates
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    // onClick={() => handleOpenModal()}
                    onClick={()=>navigate("/create-whatsapp-template")}
                >
                    Create New
                </Button>
            </Box>

            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : templates.length === 0 ? (
                <Paper sx={{ p: 3, textAlign: "center" }}>
                    <Typography variant="h6">No templates found</Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                        Click the "Create New" button to add your first template
                    </Typography>
                </Paper>
            ) : (
                <Grid container spacing={3}>
                    {templates.map((template) => (
                        <Grid item xs={12} sm={6} md={4} key={template.id}>
                            <Card
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    transition: "box-shadow 0.3s",
                                    "&:hover": {
                                        boxShadow: 3,
                                    },
                                }}
                            >
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="h2"
                                        sx={{
                                            fontWeight: "bold",
                                            mb: 2,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {template.template_title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            mb: 2,
                                            display: "-webkit-box",
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {template.template}
                                    </Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mt: 1,
                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            Created:{" "}
                                            {formatDate(template.created_at)}
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            Updated:{" "}
                                            {formatDate(template.updated_at)}
                                        </Typography>
                                    </Box>
                                </CardContent>
                                <CardActions
                                    sx={{ justifyContent: "flex-end" }}
                                >
                                    <IconButton
                                      aria-label="view"
                                      title="View"
                                      onClick={() =>
                                      handleViewTemplate(template)
                                      }
                                    >
                                     <Info color= 'info.main' />
                                     </IconButton>
                                    <IconButton
                                        aria-label="edit"
                                        onClick={() =>
                                            // handleOpenModal(template)
                                            navigate("/edit-whatsapp-template", { state: { template , isEditing: true} } )
                                        }

                                        //  onClick={()=>navigate("/edit-whatsapp-template")}
                                    >
                                        <EditIcon color="primary" />
                                    </IconButton>
                                    <IconButton
                                        aria-label="delete"
                                        onClick={() =>
                                            handleDeleteTemplate(template.id)
                                        }
                                    >
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}

            {/* Edit/Create Modal */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="template-modal-title"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                        }}
                    >
                        <Typography
                            id="template-modal-title"
                            variant="h6"
                            component="h2"
                        >
                            {isEditing
                                ? "Edit Template"
                                : "Create New Template"}
                        </Typography>
                        <IconButton onClick={handleCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <TextField
                        fullWidth
                        label="Template Title"
                        name="template_title"
                        value={
                            isEditing
                                ? currentTemplate?.template_title || ""
                                : newTemplate.template_title || ""
                        }
                        onChange={handleInputChange}
                        sx={{ mb: 3 }}
                    />

                    <TextField
                        fullWidth
                        label="Template Content"
                        name="template"
                        multiline
                        rows={10}
                        value={
                            isEditing
                                ? currentTemplate?.template || ""
                                : newTemplate.template || ""
                        }
                        onChange={handleInputChange}
                        sx={{ mb: 3 }}
                    />

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={handleCloseModal}
                            startIcon={<CloseIcon />}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSaveTemplate}
                            startIcon={<SaveIcon />}
                            disabled={
                                isEditing
                                    ? !currentTemplate?.template_title ||
                                      !currentTemplate?.template
                                    : !newTemplate.template_title || !newTemplate.template
                            }
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            </Modal>

               {/* View Title/Contents */}
                      <Modal
                  open={openViewModal}
                  onClose={handleCloseViewModal}
                  aria-labelledby="template-modal-title"
                  BackdropProps={{
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.8)',
                      backdropFilter: 'blur(4px)'
                    }
                  }}
                >
                  <Paper
                    elevation={24}
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: { xs: '95%', sm: '90%', md: 600, lg: 700 },
                      maxWidth: '90vw',
                      bgcolor: 'background.paper',
                      borderRadius: 3,
                      p: { xs: 2, sm: 3 },
                      maxHeight: '85vh',
                      overflow: 'hidden',
                      border: `1px solid ${theme.palette.divider}`,
                      boxShadow: theme.shadows[10]
                    }}
                  >
                    {/* Header */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 2,
                        pb: 1,
                        borderBottom: `2px solid ${theme.palette.primary.main}20`
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                          id="template-modal-title"
                          variant="h6"
                          fontWeight="bold"
                        //   color="primary.main"
                        >
                          Template Details
                        </Typography>
                      </Box>
                      <IconButton
                        onClick={handleCloseViewModal}
                        sx={{
                          color: 'text.secondary',
                          '&:hover': {
                            backgroundColor: 'primary.main',
                            color: 'white'
                          }
                        }}
                      >
                        <Close />
                      </IconButton>
                    </Box>
            
                    {/* Content */}
                    {selectedTemplate && (
                      <Box sx={{ overflowY: 'auto', maxHeight: 'calc(85vh - 180px)' }}>
                        {/* Title Section */}
                           <Chip
                            label="Title"
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ mb: 1 }}
                          />
                        <Box
                          sx={{
                            mb: 3,
                            p: 2,
                            backgroundColor: 'primary.light',
                            borderRadius: 2,
                            borderLeft: `4px solid ${theme.palette.primary.main}`
                          }}
                        >
                       
                          <Typography
                            variant="h5"
                            fontWeight="bold"
                            sx={{
                              wordWrap: 'break-word',
                              wordBreak: 'break-word',
                              lineHeight: 1.4,
                            //   color: 'primary.dark'
                            color:"white"
                            }}
                          >
                            {selectedTemplate.template_title}
                          </Typography>
                        </Box>
            
                        {/* Content Section */}
                        <Box sx={{ mb: 3 }}>
                          <Chip
                            label="Content"
                            size="small"
                            color="secondary"
                            variant="outlined"
                            sx={{ mb: 1 }}
                          />
                          <Paper
                            variant="outlined"
                            sx={{
                              p: 2,
                              backgroundColor: 'grey.50',
                              borderRadius: 2,
                              border: `1px solid ${theme.palette.divider}`
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                whiteSpace: 'pre-line',
                                wordWrap: 'break-word',
                                wordBreak: 'break-word',
                                lineHeight: 1.6,
                                fontSize: '1rem',
                                color: 'text.primary'
                              }}
                            >
                              {selectedTemplate.template}
                            </Typography>
                          </Paper>
                        </Box>
            
                        <Divider sx={{ my: 2 }} />
            
                        {/* Metadata Section */}
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: 'space-between',
                            gap: 1,
                            p: 1,
                            backgroundColor: 'grey.100',
                            borderRadius: 2
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <CalendarToday sx={{ fontSize: 16, color: 'success.main' }} />
                            <Typography variant="caption" color="text.secondary" fontWeight="medium">
                              Created: {formatDate(selectedTemplate.created_at)}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Update sx={{ fontSize: 16, color: 'info.main' }} />
                            <Typography variant="caption" color="text.secondary" fontWeight="medium">
                              Updated: {formatDate(selectedTemplate.updated_at)}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
            
                    {/* Footer Buttons */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 3,
                        pt: 2,
                        borderTop: `1px solid ${theme.palette.divider}`
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={handleCloseViewModal}
                        startIcon={<Close />}
                      >
                        Close
                      </Button>
                    </Box>
                  </Paper>
                </Modal>
        </Box>
    );
};

export default CreateTemplate;
